import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { formatDateToDDMMAAAA } from "../../../../../functions/kit-mdtw/dates";
import { useTableColumnPreference } from "../../../../../hooks/useTableColumnPreference";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import SeleccionContext from "../../../../../context/Seleccion/SeleccionContext";
import ActionMassive from "./ActionMassive";
import {
  ICandidatoInhabilitado,
  ICandidatoPendiente,
} from "../../../../../interfaces/ISeleccion";
import IconRegistroCandidato from "../../../../ui/icons-seleccion/IconRegistroCandidato";
import IconLoading from "../../../../ui/kit-svg/IconLoading";
import CircularProgress from "@mui/material/CircularProgress";
import IconAsignarProceso from "../../../../ui/icons-seleccion/IconAsignarProceso";
import ModalUpdateCandidate from "../../../../ui/kit-mdtw/modals/modalUpdateCandidate/ModalUpdateCandidate";
import ModalEncuesta from "../../../Campaign/ModalEncuesta";
import IconBloquear from "../../../../ui/icons-seleccion/IconBloquear";
import IconDescarte from "../../../../ui/icons-seleccion/IconDescarte";
import ModalGenerico from "../../../../ui/kit-modal/ModalGenerico";
import FooterTablePagination from "../../../../ui/kit-mdtw/table/FooterTablePagination";
import ModalDescartarBloquear from "../../../../ui/kit-modal/bloquearDescartar/ModalDescartarBloquear";
import Tooltip from "../../../../ui/kit-mdtw/tooltip/Tooltip";
import ModalAsignarProceso from "../../RegistroHabilitado/Modal/ModalAsignarProceso";
import NuevoCandidato from "../../../../ui/groups/NuevoCandidato";
import IconCandidatoReclutado from "../../../../ui/kit-svg/icon-porvalidar-profesional/IconCandidatoReclutado";
import PillValidacionCedula from "../../../../ui/groups/PillValidacionCedula";
import IconCandidatoPostulado from "../../../../ui/kit-svg/icon-porvalidar-profesional/IconCandidatoPostulado";
import IconCandidatoSugerido from "../../../../ui/kit-svg/icon-porvalidar-profesional/IconCandidatoSugerido";
import FilterChips from "../../../../ui/FilterChips";
import TableSkeleton from "../../../../ui/kit-mdtw/table/TableSkeleton";
import IconSolicitarCandidato from "../../../../ui/icons-seleccion/IconSolicitarCandidato";
import ModalSolicitarRegistro from "../../RegistroPorValidarMasivo/Modal/ModalSolicitarRegistro";

// Columnas alternables (selección y acciones son fijas). Coincide con las claves
// válidas del backend (SELECCION_PROFESIONAL_POR_VALIDAR).
const COLUMN_DEFINITIONS = [
  { key: "estado", label: "Estado" },
  { key: "validacion", label: "Validación" },
  { key: "nombre", label: "Nombre" },
  { key: "rut", label: "Rut" },
  { key: "proceso", label: "Proceso" },
  { key: "cliente", label: "Cliente" },
  { key: "fechaPostulacion", label: "Fecha Postulación" },
  { key: "reclutador", label: "Reclutador" },
] as const;

const TablaCandidatoPendiente = () => {
  const {
    token,
    userId,
    listaCandidatoPendiente,
    getCandidatoPendiente,
    getCandidatoValidado,
    putAvanzarProceso,
    getRutVerificado,
    getDocument,
    postSolicitarCandidato,
  } = useContext(SeleccionContext);
  const [isLoadingTable, setIsLoadingTable] = useState<boolean | undefined>(
    undefined
  );
  const [isErrorTable, setIsErrorTable] = useState<boolean | undefined>(
    undefined
  );
  const [listadoSeleccionado, setListadoSeleccionado] = useState<string[]>([]);
  const [isOpenModalCampaign, setIsOpenModalCampaign] =
    useState<boolean>(false);
  const [isOpenModalAsignarProceso, setIsOpenModalAsignarProceso] =
    useState<boolean>(false);
  const [isOpenModalBloquear, setIsOpenModalBloquear] =
    useState<boolean>(false);
  const [isOpenModalDescartar, setIsOpenModalDescartar] =
    useState<boolean>(false);
  const [candidateSelect, setCandidateSelect] = useState<any[]>([]);
  const [currentCandidates, setCurrentCandidates] = useState<string[]>([]);
  const [resultBusperId, setResultBusperId] = useState<string | undefined>(
    undefined
  );
  const [isOpenModalUpdateCandidate, setIsOpenModalUpdateCandidate] =
    useState<boolean>(false);
  const [selectedReclutadorId, setSelectedReclutadorId] = useState<string | undefined>(undefined);
  const [selectedReclutador, setSelectedReclutador] = useState<string | undefined>(undefined);
  const [buttonDisabled, setButtonDisabled] = useState<boolean>(true);
  const [isFree, setIsFree] = useState<boolean | undefined>(undefined);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [loadingRut, setLoadingRut] = useState<string | null>(null);
  const [messageSpanish, setMessageSpanish] = useState<string>(
    "Ingrese Rut y presione Revisar Rut para consultar su estado en el sistema"
  );
  const [gridCandidatoPendiente, setGridCandidatoPendiente] = useState<any[]>(
    []
  );
  const [isOpenModalSolicitar, setIsOpenModalSolicitar] = useState<boolean>(false);
  const [solicitudes, setSolicitudes] = useState<any>([]);
  const [candidatesSolicitar, setCandidatesSolicitar] = useState<any[]>([]);
  const [selectedProcesoDestino, setSelectedProcesoDestino] = useState<string | undefined>(undefined);
  const [selectedComentario, setSelectedComentario] = useState<string>("");
  const [offset, setOffset] = useState<any>({
    offset: { value: undefined, valid: true },
    pages: 1,
  });
  const [paginationData, setPaginationData] = useState<any>({});
  // Buscador global de la tabla (todas las columnas, en el backend).
  const [searchValue, setSearchValue] = useState<string>("");
  const searchRef = useRef<string>("");
  const [localStorageFilter, setLocalStorageFilter] = useState<string>(
    "filtroCandidatoPendiente"
  );
  const [candidates, setCandidates] = useState<any>([]);
  const [formFilter, setFormFilter] = useState<any>({
    estado: [],
    nombre: [],
    rut: [],
    proceso: [],
    cliente: [],
    fechaPostulacion: [],
    tipoProceso: ["PROFESIONAL"],
    reclutador: [],
    cedula: [],
  });

  // Preferencia de columnas visibles (misma lógica que Postulaciones).
  const loggedUserId = useMemo(() => sessionStorage.getItem("usuarioId") ?? "", []);
  const {
    visibleColumnKeys,
    setVisibleColumnKeys,
    isSaving: isSavingColumns,
    isSynchronized: isColumnsSynchronized,
  } = useTableColumnPreference({
    table: "SELECCION_PROFESIONAL_POR_VALIDAR",
    storageNamespace: "seleccion-profesional-por-validar",
    columnDefinitions: COLUMN_DEFINITIONS,
    loggedUserId,
  });
  const isCol = (key: string): boolean => visibleColumnKeys.includes(key as any);
  const visibleColCount = 2 + visibleColumnKeys.length; // checkbox + acciones fijas

  useEffect(() => {
    listRefresh();
  }, [token, localStorage.getItem(localStorageFilter), offset.pages, offset.offset, searchValue]);

  const handleSearch = (term: string): void => {
    searchRef.current = term;
    setSearchValue(term);
    setOffset((prev: any) => ({ ...prev, pages: 1 }));
  };

  useEffect(() => {
    if (listaCandidatoPendiente) {
      const arrayList = listaCandidatoPendiente.map(
        (item: ICandidatoInhabilitado) => item.personaDNI
      );
      setCurrentCandidates(arrayList);
      setGridCandidatoPendiente([...listaCandidatoPendiente]);
    }
  }, [listaCandidatoPendiente]);

  const listRefresh = async (): Promise<void> => {
    if (token) {
      const busPerIdList = (listaCandidatoPendiente || [])
        .filter((item: any) => listadoSeleccionado.includes(item.personaDNI))
        .map((item: any) => item.busPerId)
        .filter(Boolean);
      if (localStorage.getItem(localStorageFilter)) {
        const copyStorage: any = localStorage.getItem(localStorageFilter);
        const copyStorageChange = { ...JSON.parse(copyStorage), busPerIdList };
        copyStorageChange.tipoProceso = ["PROFESIONAL"];
        copyStorageChange.search = searchRef.current;
        await getCandidatoPendiente({
          token,
          filtros: copyStorageChange,
          setIsErrorTable,
          setIsLoadingTable,
          setPaginationData,
          page: offset.pages ?? 1,
          limit: offset.offset.value?.code ?? 10,
        });
      } else {
        await getCandidatoPendiente({
          token,
          filtros: { ...formFilter, busPerIdList, search: searchRef.current },
          setIsErrorTable,
          setIsLoadingTable,
          setPaginationData,
          page: offset.pages ?? 1,
          limit: offset.offset.value?.code ?? 10,
        });
      }
    }
  };

  const handleClickAddOrRemoveChoise = (prompts: any): void => {
    const { personaDNI } = prompts;
    const arrayList: string[] = [...listadoSeleccionado];

    if (!arrayList.includes(personaDNI)) {
      arrayList.push(personaDNI);
    } else {
      const position: number = arrayList.findIndex(
        (item: string) => item === personaDNI
      );
      arrayList.splice(position, 1);
    }
    setListadoSeleccionado(arrayList);
  };

  const handleClickAddAll = (): void => {
    const arrayListado: string[] = [...listadoSeleccionado];

    if (listadoSeleccionado.length < currentCandidates.length) {
      currentCandidates
        .filter(
          (personaDNI: string) => !listadoSeleccionado.includes(personaDNI)
        )
        .map((personaDNI: string) => arrayListado.push(personaDNI));
    } else {
      arrayListado.splice(0, currentCandidates.length);
    }
    setListadoSeleccionado(arrayListado);
  };

  const handleClickVerificarRut = (rowData: any): void => {
    const { personaDNI, reclutadorId, reclutador } = rowData;
    setCandidateSelect([personaDNI]);
    setSelectedReclutadorId(reclutadorId);
    setSelectedReclutador(reclutador);
    setLoadingRut(personaDNI);
    getRutVerificado({
      personaRut: personaDNI,
      setIsFree,
      setMessageSpanish,
      setLoading: (val: boolean) => { setIsLoading(val); if (!val) setLoadingRut(null); },
      setButtonDisabled,
      consultaRut: false,
      setIsOpenModalUpdateCandidate,
      token,
    });
    getDocument({ personaDNI: personaDNI, token });
  };

  const handleClickAsignarProceso = (values: any): void => {
    const { personaDNI } = values;
    setCandidateSelect([personaDNI]);
    setIsOpenModalAsignarProceso(true);
  };

  const handleClickBloquearCandidato = (values: any): void => {
    const { personaDNI } = values;
    setCandidateSelect([personaDNI]);
    setIsOpenModalBloquear(true);
  };

  const handleClickDescartarCandidato = (values: any): void => {
    const { personaDNI } = values;
    setCandidateSelect([personaDNI]);
    setIsOpenModalDescartar(true);
  };

  const handleClickSolicitar = (values: any): void => {
    const { personaDNI, primerNombre, primerApellido, reclutador, busquedaId, fechaPostulacion } = values;
    setIsOpenModalSolicitar(true);
    setCandidateSelect([personaDNI]);
    setCandidatesSolicitar([{ busquedaId, primerNombre, primerApellido, reclutador, fechaCreacion: fechaPostulacion }]);
  };

  const handleClickSolicitarCandidato = async (args?: { procesoDestino?: string; comentario?: string }): Promise<void> => {
    const procesoId = args?.procesoDestino ?? selectedProcesoDestino;
    const comentario = args?.comentario ?? selectedComentario ?? "";
    const dnis = args ? listadoSeleccionado : candidateSelect;
    if (token && procesoId) {
      await postSolicitarCandidato({
        token,
        solicitudes: dnis.map((dni: string) => {
          const candidate = listaCandidatoPendiente?.find((c: any) => c.personaDNI === dni);
          return { personaId: candidate?.personaId ?? dni, procesoId, comentario };
        }),
      });
      listRefresh();
    }
  };

  const handleAvanzarProceso = async (values: any): Promise<void> => {
    const { setIsOpenModalNoProcesado } = values;
    if (token) {
      await putAvanzarProceso({
        token,
        procesos: candidates,
        setIsOpenModalNoProcesado,
      });
      listRefresh();
      await getCandidatoValidado({
        token,
        filtros: { tipoProceso: ["PROFESIONAL"] },
      });
    }
  };

  return (
    <>
      <NuevoCandidato getCandidates={listRefresh} />
      <section className="content-seleccion-multiple">
        <div className="content-multiple">
          <label className="title-multiple">
            <span
              className={`selects-badge${listadoSeleccionado.length === 0 ? " inactive" : ""}`}
              style={{ transition: "background 0.3s ease, color 0.3s ease, font-weight 0.3s ease" }}
            >
              {listadoSeleccionado.length > 0
                ? `${listadoSeleccionado.length} ítem${listadoSeleccionado.length !== 1 ? "s" : ""} seleccionado${listadoSeleccionado.length !== 1 ? "s" : ""}`
                : "0 ítems seleccionados"}
            </span>
          </label>
        </div>
      </section>
      <section
        className="content-seleccion-multiple action-in-line margin-top-20"
        style={{ flexDirection: "column", alignItems: "stretch" }}
      >
        <ActionMassive
          listadoSeleccionado={listadoSeleccionado}
          setListadoSeleccionado={setListadoSeleccionado}
          localStorageFilter={localStorageFilter}
          listRefresh={listRefresh}
          searchValue={searchValue}
          onSearch={handleSearch}
          formFilter={formFilter}
          setFormFilter={setFormFilter}
          handleAvanzarProceso={handleAvanzarProceso}
          candidates={candidates}
          setCandidates={setCandidates}
          solicitudes={solicitudes}
          setSolicitudes={setSolicitudes}
          handleClickSolicitarCandidato={handleClickSolicitarCandidato}
          columnDefinitions={COLUMN_DEFINITIONS}
          visibleColumnKeys={visibleColumnKeys}
          setVisibleColumnKeys={(keys) => setVisibleColumnKeys(keys as any)}
          isSavingColumns={isSavingColumns}
          isColumnsSynchronized={isColumnsSynchronized}
        />
      </section>

      <section className="content-header-table">
        <label className="title-header-table">Candidatos Pendientes</label>
      </section>

      {!isLoadingTable ? (
        <>
          {isErrorTable ? (
            <div className="container-is-error-table">
              Error al cargar los datos.
            </div>
          ) : (
            <>
              <main className="container-table-list">
                <table className="content-table">
                  <thead className="thead-table-registros">
                    <tr>
                      <th className="th-table-registros col-w-check">
                        <button
                          onClick={handleClickAddAll}
                          className="button-select"
                        >
                          {listadoSeleccionado.length ==
                            currentCandidates.length &&
                            listadoSeleccionado.length > 0 ? (
                            <CheckBoxIcon />
                          ) : (
                            <CheckBoxOutlineBlankIcon />
                          )}
                        </button>
                      </th>
                      {isCol("estado") && <th className="th-table-registros th-col-estado">Estado</th>}
                      {isCol("validacion") && <th className="th-table-registros col-w-validacion">Validación</th>}
                      {isCol("nombre") && <th className="th-table-registros">Nombre</th>}
                      {isCol("rut") && <th className="th-table-registros col-w-rut">Rut</th>}
                      {isCol("proceso") && <th className="th-table-registros">Proceso</th>}
                      {isCol("cliente") && <th className="th-table-registros">Cliente</th>}
                      {isCol("fechaPostulacion") && (
                        <th className="th-table-registros col-w-fecha">
                          Fecha <br></br>Postulación
                        </th>
                      )}
                      {isCol("reclutador") && <th className="th-table-registros">Reclutador</th>}
                      <th className="th-table-registros col-w-acciones">Acciones</th>
                    </tr>
                  </thead>
                  <tbody className="tbody-table-registros">
                    {gridCandidatoPendiente &&
                      gridCandidatoPendiente.map(
                        (item: ICandidatoPendiente) => {
                          const {
                            personaDNI,
                            reclutadorId,
                            reclutador,
                            primerNombre,
                            primerApellido,
                            clienteNombre,
                            busquedaId,
                            fechaPostulacion,
                            origenRegistro,
                            veredictoCedula,
                            detalleCedula,
                          } = item;
                          return (
                            <>
                              <tr
                                key={personaDNI}
                                className={`tr-table-registros ${listadoSeleccionado.includes(personaDNI) &&
                                  "checkeado"
                                  }`}
                              >
                                <td className="td-table-registros col-w-check">
                                  <button
                                    className="button-select"
                                    onClick={() =>
                                      handleClickAddOrRemoveChoise({
                                        personaDNI,
                                      })
                                    }
                                  >
                                    {listadoSeleccionado.includes(
                                      personaDNI
                                    ) ? (
                                      <CheckBoxIcon />
                                    ) : (
                                      <CheckBoxOutlineBlankIcon />
                                    )}
                                  </button>
                                </td>
                                {isCol("estado") && (
                                <td className="td-table-registros">
                                  <section className="content-state">
                                    {origenRegistro === "RECLUTADO" && (
                                      <>
                                        <IconCandidatoReclutado fill="#0065DD" />
                                        <div className="content-state-text">
                                          <label className="title registro-azul">
                                            Candidato Reclutado
                                          </label>
                                        </div>
                                      </>
                                    )}
                                    {origenRegistro === "POSTULADO" && (
                                      <>
                                        <IconCandidatoPostulado fill="#FF0081" />
                                        <div className="content-state-text">
                                          <label className="title registro-rosado">
                                            Candidato Postulado
                                          </label>
                                          <label className="message">
                                            Datos ingresados por<br></br>
                                            postulante
                                          </label>
                                        </div>
                                      </>
                                    )}
                                    {origenRegistro === "SUGERIDO" && (
                                      <>
                                        <IconCandidatoSugerido fill="#48566B" />
                                        <div className="content-state-text">
                                          <label className="title registro-gris">
                                            Candidato Sugerido
                                          </label>
                                          <label className="message">
                                            Candidato con xx%<br></br>
                                            efectividad de contacto
                                          </label>
                                        </div>
                                      </>
                                    )}
                                  </section>
                                </td>
                                )}
                                {isCol("validacion") && (
                                <td className="td-table-registros col-w-validacion">
                                  <PillValidacionCedula
                                    veredictoCedula={veredictoCedula}
                                    detalleCedula={detalleCedula}
                                  />
                                </td>
                                )}
                                {isCol("nombre") && (
                                <td className="td-table-registros">
                                  {primerNombre} {primerApellido}
                                </td>
                                )}
                                {isCol("rut") && (
                                <td className="td-table-registros col-w-rut">
                                  {personaDNI}
                                </td>
                                )}
                                {isCol("proceso") && (
                                <td className="td-table-registros">
                                  {busquedaId}
                                </td>
                                )}
                                {isCol("cliente") && (
                                <td className="td-table-registros">
                                  {clienteNombre}
                                </td>
                                )}
                                {isCol("fechaPostulacion") && (
                                <td className="td-table-registros col-w-fecha">
                                  {formatDateToDDMMAAAA({
                                    date: fechaPostulacion,
                                    format: "/",
                                  })}
                                </td>
                                )}
                                {isCol("reclutador") && (
                                <td className="td-table-registros">
                                  {reclutador}
                                </td>
                                )}
                                <td className="td-table-registros col-w-acciones">
                                  <section className="content-icon-table">
                                    <Tooltip text="Ver Registro">
                                      <button
                                        onClick={() =>
                                          handleClickVerificarRut({
                                            personaDNI,
                                            reclutadorId,
                                            reclutador,
                                          })
                                        }
                                        className="button-content"
                                        disabled={loadingRut === personaDNI}
                                      >
                                        {loadingRut === personaDNI ? (
                                          <CircularProgress size={18} thickness={4} sx={{ color: "#0065DD" }} />
                                        ) : (
                                          <IconRegistroCandidato
                                            fill={"#0065DD"}
                                          />
                                        )}
                                      </button>
                                    </Tooltip>

                                    <Tooltip text="Asignar Proceso">
                                      <button
                                        onClick={() =>
                                          handleClickAsignarProceso({
                                            personaDNI,
                                          })
                                        }
                                        className="button-content"
                                      >
                                        <IconAsignarProceso fill={"#0065DD"} />
                                      </button>
                                    </Tooltip>

                                    <Tooltip text="Bloquear">
                                      <button
                                        onClick={() =>
                                          handleClickBloquearCandidato({
                                            personaDNI,
                                          })
                                        }
                                        className="button-content"
                                      >
                                        <IconBloquear fill={"#BE2A2A"} />
                                      </button>
                                    </Tooltip>
                                    <Tooltip text="Descartar">
                                      <button
                                        onClick={() =>
                                          handleClickDescartarCandidato({
                                            personaDNI,
                                          })
                                        }
                                        className="button-content"
                                      >
                                        <IconDescarte fill={"#BE2A2A"} />
                                      </button>
                                    </Tooltip>
                                    {reclutadorId !== userId && (
                                      <Tooltip text="Solicitar Candidato">
                                        <button
                                          onClick={() => handleClickSolicitar({ personaDNI, primerNombre, primerApellido, reclutador, busquedaId, fechaPostulacion })}
                                          className="button-content"
                                        >
                                          <IconSolicitarCandidato fill={"#E3A000"} />
                                        </button>
                                      </Tooltip>
                                    )}
                                  </section>
                                </td>
                              </tr>
                            </>
                          );
                        }
                      )}
                  </tbody>
                </table>
              </main>
              <FooterTablePagination
                paginationData={paginationData}
                offset={offset}
                setOffset={setOffset}
              />
            </>
          )}
        </>
      ) : (
        <TableSkeleton cols={visibleColCount} />
      )}

      {isOpenModalUpdateCandidate && (
        <ModalUpdateCandidate
          title="Registro Candidato"
          subTitle="Puede cambiar al candidato de proceso en cualquier momento, Todos los datos con (*) son obligatorios y deben ser completados antes de avanzar al candidato a la siguiente etapa del proceso."
          setIsOpenModalUpdateCandidate={setIsOpenModalUpdateCandidate}
          setResultBusperId={setResultBusperId}
          token={token}
          isLoadingModal={isLoading}
          rut={candidateSelect[0]}
          reclutadorId={selectedReclutadorId}
          reclutador={selectedReclutador}
          getCandidates={listRefresh}
          onChangeBack={() => {
            setIsOpenModalUpdateCandidate(false);
            const body = document.querySelector("body");
            if (body) {
              body.style.overflowY = "auto";
            }
          }}
          onChangeGo={() => {
            const body = document.querySelector("body");
            if (body) {
              body.style.overflowY = "auto";
            }
          }}
        />
      )}

      {isOpenModalCampaign && (
        <ModalEncuesta
          modalStyle="confirm"
          title="Solicite realizar la siguiente encuesta al candidato"
          onChangeBack={() => {
            setIsOpenModalCampaign(false);
            const body = document.querySelector("body");
            if (body) {
              body.style.overflowY = "auto";
            }
          }}
          buttonBack="Cancelar"
          busPerId={resultBusperId}
        />
      )}

      {isOpenModalAsignarProceso && (
        <ModalGenerico
          title="Asignar Proceso"
          width="w-70"
          subtitle="Selecciona Grupo y/o Proceso a asignar a la selección"
          onChangeBack={() => {
            setIsOpenModalAsignarProceso(false);
            const body = document.querySelector("body");
            if (body) {
              body.style.overflowY = "auto";
            }
          }}
        >
          <ModalAsignarProceso
            list={candidateSelect}
            listSelect={listaCandidatoPendiente}
            getListRefresh={listRefresh}
            localStorageFilter={localStorageFilter}
            setListadoSeleccionado={setListadoSeleccionado}
            formFilter={formFilter}
            onChangeBack={() => {
              setIsOpenModalAsignarProceso(false);
              const body = document.querySelector("body");
              if (body) {
                body.style.overflowY = "auto";
              }
            }}
          />
        </ModalGenerico>
      )}

      {isOpenModalBloquear && (
        <ModalGenerico
          title="BLOQUEO DE CANDIDATOS"
          width="w-70"
          subtitle="Estás por bloquear la siguiente selección de candidatos:"
          onChangeBack={() => {
            setIsOpenModalBloquear(false);
            const body = document.querySelector("body");
            if (body) {
              body.style.overflowY = "auto";
            }
          }}
        >
          <ModalDescartarBloquear
            typeExclusion="bloqueo"
            getListRefresh={listRefresh}
            listSelect={listaCandidatoPendiente ?? []}
            localStorageFilter={localStorageFilter}
            setListadoSeleccionado={setListadoSeleccionado}
            formFilter={formFilter}
            onChangeBack={() => {
              setIsOpenModalBloquear(false);
              const body = document.querySelector("body");
              if (body) {
                body.style.overflowY = "auto";
              }
            }}
            list={candidateSelect}
          />
        </ModalGenerico>
      )}

      {isOpenModalDescartar && (
        <ModalGenerico
          title="DESCARTE DE CANDIDATOS"
          width="w-70"
          subtitle="Estás por descartar la siguiente selección de candidatos:"
          onChangeBack={() => {
            setIsOpenModalDescartar(false);
            const body = document.querySelector("body");
            if (body) {
              body.style.overflowY = "auto";
            }
          }}
        >
          <ModalDescartarBloquear
            typeExclusion="descarte"
            getListRefresh={listRefresh}
            listSelect={listaCandidatoPendiente ?? []}
            localStorageFilter={localStorageFilter}
            setListadoSeleccionado={setListadoSeleccionado}
            formFilter={formFilter}
            onChangeBack={() => {
              setIsOpenModalDescartar(false);
              const body = document.querySelector("body");
              if (body) {
                body.style.overflowY = "auto";
              }
            }}
            list={candidateSelect}
          />
        </ModalGenerico>
      )}

      {isOpenModalSolicitar && (
        <ModalGenerico
          width="w-90"
          title="SOLICITAR CANDIDATO"
          onChangeBack={() => {
            setIsOpenModalSolicitar(false);
            setCandidateSelect([]);
            setSelectedProcesoDestino(undefined);
            setSelectedComentario("");
          }}
          buttonBackText="Cerrar"
          buttonGoText="Solicitar"
          buttonGoStyle="confirm"
          buttonGoDisable={!!selectedProcesoDestino}
          onChangeGo={() => {
            handleClickSolicitarCandidato();
            setIsOpenModalSolicitar(false);
            setCandidateSelect([]);
            setSelectedProcesoDestino(undefined);
            setSelectedComentario("");
          }}
        >
          <ModalSolicitarRegistro
            rut={candidateSelect}
            candidates={candidatesSolicitar}
            solicitudes={solicitudes}
            setSolicitudes={setSolicitudes}
            onChangeBack={() => {
              setIsOpenModalSolicitar(false);
              setCandidateSelect([]);
              setCandidatesSolicitar([]);
              setSelectedProcesoDestino(undefined);
              setSelectedComentario("");
            }}
            handleClickSolicitarCandidato={handleClickSolicitarCandidato}
            onSelectProceso={(value: string) => setSelectedProcesoDestino(value)}
            onComentario={(value: string) => setSelectedComentario(value)}
          />
        </ModalGenerico>
      )}
    </>
  );
};

export default TablaCandidatoPendiente;
